let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4ukIY")).then(() => parcelRequire('PEC4K'));